import { Component, OnInit } from '@angular/core';
import { BaseModalContainer, ModalContainerService, ModalService, UserService, BaseDataService } from 'yt-ng-framework';
import { ResenjeZaPlacenoOdsustvo } from './resenje-za-placeno-odsustvo';
import { ActivatedRoute } from '@angular/router';
import { Validators } from '@angular/forms';

@Component({
  selector: 'yt-resenje-za-placeno-odsustvo',
  templateUrl: './resenje-za-placeno-odsustvo.component.html'
})
export class ResenjeZaPlacenoOdsustvoComponent
extends BaseModalContainer<ResenjeZaPlacenoOdsustvo>
implements OnInit {

  constructor(
    protected modalContainerService: ModalContainerService<ResenjeZaPlacenoOdsustvo>,
    protected activatedRoute: ActivatedRoute,
    protected baseDataService: BaseDataService,
    protected modalService: ModalService,
    protected userService: UserService
  ) {
    super(modalContainerService, activatedRoute, modalService, userService);
  }

  ngOnInit() {
    super.ngOnInit();
  }

}
